import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    language: '',
    page_loading: false,
    key_res_loading: false,
    info: null,
    keywords: [],
    responses: [],
    avatar_motion_list: [],
    intent_nav: {},
    is_submit_btn_disable: false,
    editMenu: false
  },
  mutations: {
    SET_QUESTION_TOPIC_LANGUAGE(state, payload) {
      state.language = payload
    },
    SET_QUESTION_TOPIC_PAGE_LOADING(state, payload) {
      state.page_loading = payload
    },
    SET_QUESTION_TOPIC_KEY_RES_LOADING(state, payload) {
      state.key_res_loading = payload
    },
    SET_QUESTION_TOPIC_INFO(state, payload) {
      state.info = payload
    },
    SET_QUESTION_TOPIC_KEYWORDS(state, payload) {
      state.keywords = payload
    },
    SET_QUESTION_TOPIC_RESPONSES(state, payload) {
      state.responses = payload
    },
    SET_QUESTION_TOPIC_AVATAR_MOTION_LIST(state, payload) {
      state.avatar_motion_list = payload
    },
    SET_QUESTION_TOPIC_INTENT_NAV(state, payload) {
      state.intent_nav = payload
    },
    SET_QUESTION_TOPIC_IS_SUBMIT_BTN_DISABLE(state, payload) {
      state.is_submit_btn_disable = payload
    },
    SET_QUESTION_TOPIC_EDIT_MENU(state, payload) {
      state.editMenu = payload
    },
    RESET_QUESTION_TOPIC(state) {
      state.info = null
      state.keywords = []
      state.responses = []
      state.intent_nav = {}
    }
  },
  actions: {
    async fetchQuestionTopicDetails({ commit, dispatch }, { intent_id }) {
      try {
        commit('RESET_QUESTION_TOPIC')
        commit('SET_QUESTION_TOPIC_PAGE_LOADING', true)

        const [details, nav] = await Promise.all([api.getQuestionTopicList({ intent_id }), api.getQuestionTopicNav({ id: intent_id })])
        if (details.data.success && nav.data.success) {
          commit('SET_QUESTION_TOPIC_PAGE_LOADING', false)
          commit('SET_QUESTION_TOPIC_INFO', details.data.data[0])
          commit('SET_QUESTION_TOPIC_INTENT_NAV', nav.data.data)
          dispatch('fetchQuestionTopicKeywordAndResponse', { intent_id: intent_id })
        } else if (!details.data.success) throw Error(details.data.message)
        else if (!nav.data.success) throw Error(nav.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async fetchQuestionTopicKeywordAndResponse({ rootState, state, commit }, { intent_id }) {
      try {
        commit('SET_QUESTION_TOPIC_KEY_RES_LOADING', true)

        let language = state.language
        if (!language) {
          const first_language = rootState.auth.user_info.languages[0]
          commit('SET_QUESTION_TOPIC_LANGUAGE', first_language)
          language = first_language
        }

        const [keywords, response, motions] = await Promise.all([api.getKeywordList({ language, intent_id }), api.getResponseList({ language, intent_id }), api.getAvatarMotionList()])
        // const [keywords, response] = await Promise.all([api.getKeywordList({ language, intent_id }), api.getResponseList({ language, intent_id })])

        if (keywords.data.success && response.data.success && motions.data.success) {
          // if (keywords.data.success && response.data.success) {
          commit('SET_QUESTION_TOPIC_KEY_RES_LOADING', false)
          commit('SET_QUESTION_TOPIC_KEYWORDS', keywords.data.data)
          commit('SET_QUESTION_TOPIC_RESPONSES', response.data.data)
          commit('SET_QUESTION_TOPIC_AVATAR_MOTION_LIST', motions.data.data)
        } else if (!keywords.data.success) throw Error(keywords.data.message)
        else if (!response.data.success) throw Error(response.data.message)
        else if (!motions.data.success) throw Error(motions.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async updateQuestionTopicKeyword({ state, commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.updating', ''), loading: true })
        commit('SET_QUESTION_TOPIC_IS_SUBMIT_BTN_DISABLE', true)

        const language = state.language
        const response = await api.updateKeyword({ params: { ...payload, language } })
        if (response.data.success) {
          commit('SET_QUESTION_TOPIC_EDIT_MENU', false)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.success', ''), icon: 'check', timeout: '2000' })
          dispatch('searchAliasList')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_QUESTION_TOPIC_IS_SUBMIT_BTN_DISABLE', false)
        dispatch('fetchQuestionTopicKeywordAndResponse', { intent_id: payload.intent_id })
      }
    },
    async updateQuestionTopicEnableRelatedIntents({ commit, state }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.updating', Vuetify.locale.t('$vuetify.__General.question_topic')),
          loading: true
        })
        const response = await api.updateQuestionTopic({ params: payload })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.update', ''), icon: 'check', timeout: '2000' })
          state.info.is_enabled_related_intents = !state.info.is_enabled_related_intents
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async updateQuestionTopicStatus({ commit, state }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.update_question_topic_status'), loading: true })
        const response = await api.updateQuestionTopic({ params: payload })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.update', ''), icon: 'check', timeout: '2000' })
          if (state.info) state.info.is_activated = !state.info.is_activated
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async updateQuestionTopicResponseActivate({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.updating', Vuetify.locale.t('$vuetify.__Response.response')),
          loading: true
        })
        const response = await api.updateResponse({ params: payload.response })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.update', ''), icon: 'check', timeout: '2000' })
          dispatch('fetchQuestionTopicKeywordAndResponse', { intent_id: payload.intent_id })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async updateAvatarMotion({ commit, dispatch }, payload) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.updating', Vuetify.locale.t('$vuetify.__Response.response')),
          loading: true
        })
        const response = await api.updateAvatarMotion({ params: payload })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.update', ''), icon: 'check', timeout: '2000' })
          dispatch('fetchQuestionTopicKeywordAndResponse', { intent_id: payload.intent_id })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
